import {Injectable, OnDestroy} from '@angular/core';
import {environment} from '../../../environments/environment';
import {addScript} from 'app/core/helpers/dom';
import {EnvName, getEnvName} from '../../../environments/env-name';
import {RouterHelperService} from 'app/core/services/router-helper.service';
import {Subscription} from 'rxjs';

declare let window: any;

@Injectable()
export class HubspotService implements OnDestroy {
    sub = Subscription.EMPTY;

    constructor(private routerHelper: RouterHelperService) {
        this.init();
    }

    get _hsq(): any[] {
        return (window._hsq = window._hsq || []);
    }

    init() {
        this.sub.unsubscribe();
        this.sub = this.routerHelper.routeChanges$.subscribe(() => {
            console.debug(`[Hubspot] trackPageView ${document.location.pathname}`);
            // @see https://legacydocs.hubspot.com/docs/methods/tracking_code_api/track_page_view
            this._hsq.push(['setPath', document.location.pathname]);
            // Track the page view for the new page
            this._hsq.push(['trackPageView']);
        });
    }

    addHubspot(): void {
        if (getEnvName() !== EnvName.Prod) {
            return;
        }
        if (!environment.hubspotTrackingId) {
            return;
        }

        addScript(`//js.hs-scripts.com/${environment.hubspotTrackingId}.js`);
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
